import * as PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';

import { PageWrapper } from 'modules/layout';

import AddInfoForm from '../../containers/Info/AddInfoForm';

const AddInfoPage = ({
    match: {
        params: { id },
    },
}) => (
    <PageWrapper header={<FormattedMessage id="info.add.title" />}>
        <AddInfoForm categoryId={id} />
    </PageWrapper>
);

AddInfoPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default AddInfoPage;
